import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AuthShell } from "./AuthShell";
import { auth, sendPasswordResetEmail } from "@/lib/firebase";
import { Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [done, setDone] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const onSubmit = async (e) => {
        e.preventDefault();
        setError(""); setLoading(true);
        try {
            await sendPasswordResetEmail(auth, email);
            setDone(true);
        } catch (err) {
            // Don't reveal whether email exists (security)
            setDone(true);
        } finally { setLoading(false); }
    };

    return (
        <AuthShell title="Forgot password?" subtitle="Enter your email — we'll send a reset link.">
            {done ? (
                <div data-testid="forgot-done" className="bg-mint/30 border border-mint/40 rounded-2xl p-6 text-center">
                    <MailCheck className="mx-auto mb-3 text-ink" size={28}/>
                    <p className="font-display text-[22px] font-semibold tracking-tight text-ink mb-1">Check your inbox</p>
                    <p className="text-[13.5px] text-ink-muted">If <span className="font-semibold text-ink">{email}</span> matches an account, a password reset link is on its way.</p>
                </div>
            ) : (
                <form onSubmit={onSubmit} data-testid="forgot-form" className="space-y-4">
                    <div>
                        <label className="block text-[12px] font-semibold text-ink mb-1.5">Email</label>
                        <input
                            type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                            data-testid="forgot-email" placeholder="you@newsroom.com"
                            className="w-full bg-white border border-cream-300 rounded-2xl px-4 py-3 text-[15px] focus:outline-none focus:ring-2 focus:ring-coral/40 focus:border-coral transition"
                        />
                    </div>
                    {error && <p className="text-[13px] text-coral font-medium">{error}</p>}
                    <button
                        type="submit" disabled={loading} data-testid="forgot-submit"
                        className="w-full bg-ink hover:bg-coral text-cream-100 rounded-full py-3.5 text-[14.5px] font-semibold inline-flex items-center justify-center gap-2 transition-all disabled:opacity-70"
                    >
                        {loading ? <><Loader2 size={16} className="animate-spin"/> Sending…</> : <>Send reset link →</>}
                    </button>
                </form>
            )}
            <p className="text-[13px] text-ink-muted text-center pt-5">
                Back to <Link to="/login" className="text-ink font-semibold hover:text-coral">Sign in</Link>
            </p>
        </AuthShell>
    );
}
